// ModuleWrapper.jsx
import React, { useState } from 'react';
import "./moduleUpgrade.min.css";

import { useSelector, useDispatch } from 'react-redux';
import { setAction } from '../../Redux/slices/skipGetSlice';
import { useNavigate } from 'react-router-dom';
import LnModuleUpgrade from './LnModuleUpgrade';

function ModuleWrapperUpgrade() {
  const dispatch = useDispatch();


  const handleSkip = () => {
    dispatch(setAction('skip'));
    navigate('/upgrade');
  };


const [selectedModules, setSelectedModules] = useState([]);
  const navigate = useNavigate();

  const handleModuleSelect = (modules) => {
    setSelectedModules(modules); // this state is not used directly but kept for continuity
  };

  const handleGetStarted = () => {
    localStorage.setItem('selectedModules', JSON.stringify(selectedModules));
    navigate('/upgrade');
  };
  return (
    <section className="module-sec position-relative module_page">
      <div className="container">
        <div className="module-wrapper">
          <h1 className="module-core-title text-center">
            The BMS that's simple to set up and easy to use
          </h1>
          <div className="module-paragraph-wrapper text-center">
            <h2>
              Growthh BMS is a fully customizable, management platform. No code needed.
              <span>What would you like to manage with your BMS?</span>
            </h2>
          </div>
          <LnModuleUpgrade onModuleSelect={handleModuleSelect} />
          <div className="text-center mt-30">
         
            <button onClick={handleGetStarted} className="get-started-btn d-inline-flex align-items-center">
              Continue <span className="btn-arrow"><i className="fi fi-rr-arrow-small-right"></i></span>
            </button>
            <div className="mt-10 gth-markup-txt">Get full access <i className="fi fi-ss-star-christmas"></i> No credit card needed</div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ModuleWrapperUpgrade;
